'use client'

import { usePathname } from 'next/navigation'
import { Briefcase, Calendar, CalendarCheck, Settings } from 'lucide-react'
import { cn } from '@/lib/utils'
import { TracedLink } from './TracedLink'

export function MainNav() {
  const pathname = usePathname()

  return (
    <nav className="flex items-center space-x-4 lg:space-x-6 rtl:space-x-reverse">
      <TracedLink
        href="/"
        className={cn(
          'flex items-center text-sm font-medium transition-all duration-200 hover:text-primary px-3 py-2 rounded-md cursor-pointer',
          pathname === '/' || pathname === '/meetings/all'
            ? 'text-primary bg-primary/10 shadow-sm border border-primary/20'
            : 'text-muted-foreground hover:bg-muted',
        )}
      >
        <Calendar className="h-4 w-4 ml-2" />
        אסיפות
      </TracedLink>
      <TracedLink
        href="/participations"
        className={cn(
          'flex items-center text-sm font-medium transition-all duration-200 hover:text-primary px-3 py-2 rounded-md cursor-pointer',
          pathname === '/participations'
            ? 'text-primary bg-primary/10 shadow-sm border border-primary/20'
            : 'text-muted-foreground hover:bg-muted',
        )}
      >
        <CalendarCheck className="h-4 w-4 ml-2" />
        השתתפות
      </TracedLink>
      <TracedLink
        href="/holdings"
        className={cn(
          'flex items-center text-sm font-medium transition-all duration-200 hover:text-primary px-3 py-2 rounded-md cursor-pointer',
          pathname === '/holdings' || pathname === '/holdings/view'
            ? 'text-primary bg-primary/10 shadow-sm border border-primary/20'
            : 'text-muted-foreground hover:bg-muted',
        )}
      >
        <Briefcase className="h-4 w-4 ml-2" />
        החזקות
      </TracedLink>
      <TracedLink
        href="/settings"
        className={cn(
          'flex items-center text-sm font-medium transition-all duration-200 hover:text-primary px-3 py-2 rounded-md cursor-pointer',
          pathname === '/settings'
            ? 'text-primary bg-primary/10 shadow-sm border border-primary/20'
            : 'text-muted-foreground hover:bg-muted',
        )}
      >
        <Settings className="h-4 w-4 ml-2" />
        הגדרות
      </TracedLink>
    </nav>
  )
}
